"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileAddresses = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./form/validation");
const common_1 = require("../../../../common");
const PROFILE_ADDRESSES_URL = "/profile/address";
const ProfileAddresses = (props) => {
    const { open } = props;
    const { isLoading, allRows, refetch } = (0, react_hooks_1.useFetchQuery)(PROFILE_ADDRESSES_URL);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDelete } = (0, react_hooks_1.useDialogDelete)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { formatAddress } = (0, utils_1.useFormatAddress)();
    if (!open) {
        return null;
    }
    const addressCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ADDRESS, common_1.emptyAddress, {
            refetch,
            initialValues: common_1.emptyAddress,
            message: "dialogs.create",
            testId: "AddressDialogForm",
            filter: ({ addressLine1, addressLine2, city, country, isDefault, state, zip }) => ({
                addressLine1,
                addressLine2,
                city,
                country,
                isDefault,
                state,
                zip,
            }),
            url: PROFILE_ADDRESSES_URL,
            validationSchema: validation_1.addressValidationSchema,
        });
    };
    const addressEdit = (address) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.ADDRESS, address, {
            refetch,
            initialValues: address,
            message: "dialogs.edit",
            testId: "AddressDialogForm",
            filter: ({ addressLine1, addressLine2, city, country, isDefault, state, zip }) => ({
                addressLine1,
                addressLine2,
                city,
                country,
                isDefault,
                state,
                zip,
            }),
            url: PROFILE_ADDRESSES_URL,
            validationSchema: validation_1.addressValidationSchema,
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.profile.tabs.addresses", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: addressCreate, "data-testid": "EcommerceAddressCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: allRows.length, isLoading: isLoading, message: "pages.profile.addresses.empty", children: allRows.map(address => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { primary: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", gap: 2, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "subtitle1", children: formatAddress(address) }), "\u00A0", address.isDefault ? ((0, jsx_runtime_1.jsx)(ui_kit_1.Chip, { size: "small", color: "primary", label: formatMessage({ id: "pages.profile.addresses.default" }) })) : null, address.addressStatus === types_1.AddressStatus.INACTIVE ? ((0, jsx_runtime_1.jsx)(ui_kit_1.Chip, { size: "small", color: "secondary", label: formatMessage({ id: "pages.profile.addresses.inactive" }) })) : null] }), sx: { pr: 3 } }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: addressEdit(address), message: "form.tips.edit", icon: icons_material_1.Edit }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDelete(address), message: "form.tips.delete", icon: icons_material_1.Delete })] })] }, address.id))) }) }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: PROFILE_ADDRESSES_URL, refetch: refetch, getTitle: formatAddress })] }));
};
exports.ProfileAddresses = ProfileAddresses;
//# sourceMappingURL=index.js.map